"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginationPropTypes = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _interfaces = require("./interfaces");

var paginationPropTypes = {
  numberOfPages: _stencilReactDesc.PropTypes.number.isRequired.description('The total number of page numbers to display.'),
  onPageSelect: _stencilReactDesc.PropTypes.func.isRequired.description('Callback called when the user selects a page.').format('(page: number) => void'),
  selectedPage: _stencilReactDesc.PropTypes.number.isRequired.description('The index of the currently selected page, starting from 1.'),
  'aria-label': _stencilReactDesc.PropTypes.string.description('Sets the overall aria-label for the entire component.'),
  'aria-labelledby': _stencilReactDesc.PropTypes.string.description('Sets the overall aria-labelledby for the entire component.'),
  generateButtonAriaLabel: _stencilReactDesc.PropTypes.func.description('Function called to create aria-labels for the various buttons displayed by the component.').format("({\n  isNextButton?: boolean,\n  isPreviousButton?: boolean,\n  pageNumber?: number,\n  isFirstPage?: boolean,\n  isLastPage?: boolean\n}) => string"),
  getSelectedPageHiddenText: _stencilReactDesc.PropTypes.func.description('Function used to override the default announcement when selecting a page.').format("(selectedPage: number) => string"),
  variant: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.PaginationVariant)).description('Specifies what variant of the pagination should be used.')
};
exports.paginationPropTypes = paginationPropTypes;